/**
 *  Vuex Rest API
 *
 *  @model Device
 */
import Vapi from 'vuex-rest-api'
import apiConfig from '@/config/api'
import { getPaginated, createApiUrl } from '@/helpers/general'
import { axiosInstance } from '../../plugins/axios'

/**
 *  Users on REST API
 */
export default new Vapi({
  axios: axiosInstance,
  baseURL: apiConfig.url,
  state: {
    user: {},
    users: [],
    enterprise: {},
    enterprises: [],
    vendor: {},
    vendors: [],
    company: {},
    companies: [],
    department: {},
    departments: []
  }

})

  // Users
  .get({
    action: 'getUser',
    property: 'user',
    path: (params) => createApiUrl(params, 'users')
  }).get({
    action: 'getUsers',
    property: 'users',
    path: (params) => '/users'
    // path: (params) => getPaginated(params, 'users')
  }).put({
    action: 'updateUser',
    property: 'user',
    path: (params) => `/users/${params.id}`
  }).post({
    action: 'createUsers',
    property: 'user',
    path: () => '/users'
  }).delete({
    action: 'deleteUser',
    property: 'user',
    path: ({ id }) => `/users/${id}`
  }).delete({
    action: 'deleteUsers',
    property: 'user',
    path: ({ id }) => `/users/${id}`
  })

  // Relationships
  .post({
    action: 'assignRole',
    property: 'user',
    path: ({ id, role }) => `/users/${id}/assignRole`
  }).post({
    action: 'assignRole',
    property: 'user',
    path: ({ id, role }) => `/users/${id}/assignRole`
  }).post({
    action: 'givePermission',
    property: 'user',
    path: ({ id, permission }) => `/users/${id}/givePermission`
  }).post({
    action: 'attachDevice',
    property: 'user',
    path: ({ id, device }) => `/users/${id}/attachDevice`
  }).post({
    action: 'attachManyDevices',
    property: 'user',
    path: ({ id, device }) => `/users/${id}/attachDevice`
  })

  // Vendors
  .get({
    action: 'getVendor',
    property: 'vendor',
    path: ({ id }) => `/vendors/${id}?with=entities`
  }).get({
    action: 'getVendors',
    property: 'vendors',
    path: (params) => getPaginated(params, 'vendors')
  }).post({
    action: 'createVendor',
    property: 'vendors',
    path: '/vendors'
  }).post({
    action: 'attachVendorToParent',
    property: 'vendors',
    path: '/vendors/attach-to-parent'
  }).put({
    action: 'updateVendor',
    property: 'vendor',
    path: ({ id }) => `/vendors/${id}`
  }).delete({
    action: 'deleteVendor',
    property: 'vendor',
    path: ({ id }) => `/vendors/${id}`
  })

  // Enterprises
  .get({
    action: 'getEnterprise',
    property: 'enterprise',
    path: ({ id }) => `/enterprises/${id}`
  }).get({
    action: 'getEnterprises',
    property: 'enterprises',
    path: (params) => getPaginated(params, 'enterprises')
  }).post({
    action: 'createEnterprise',
    property: 'enterprise',
    path: '/enterprises'
  }).put({
    action: 'updateEnterprise',
    property: 'enterprise',
    path: ({ id }) => `/enterprises/${id}`
  }).delete({
    action: 'deleteEnterprise',
    property: 'enterprise',
    path: ({ id }) => `/enterprises/${id}`
  })

  // Departments
  .get({
    action: 'getDepartment',
    property: 'department',
    path: ({ id }) => `/departments/${id}`
  }).get({
    action: 'getDepartments',
    property: 'departments',
    path: (params) => getPaginated(params, 'departments')
  }).post({
    action: 'createDepartment',
    property: 'department',
    path: '/departments'
  }).put({
    action: 'updateDepartment',
    property: 'department',
    path: ({ id }) => `/departments/${id}`
  }).delete({
    action: 'deleteDepartment',
    property: 'department',
    path: ({ id }) => `/departments/${id}`
  })

  // Companies
  .get({
    action: 'getCompany',
    property: 'company',
    path: ({ id }) => `/companies/${id}`
  }).get({
    action: 'getCompanies',
    property: 'companies',
    path: (params) => getPaginated(params, 'companies')
  }).post({
    action: 'createCompany',
    property: 'company',
    path: '/companies'
  }).put({
    action: 'updateCompany',
    property: 'company',
    path: ({ id }) => `/companies/${id}`
  }).delete({
    action: 'deleteCompany',
    property: 'company',
    path: ({ id }) => `/companies/${id}`
  }).getStore({
    namespaced: true,
    createStateFn: true
  })
